import React, { useRef, useState } from 'react'
import PropTypes from "prop-types";
import { generateOcs } from '../../utils/ocs-generator';
import ackoContants from '../../pages/drx-page/components/drx-table/acko-drx/constants';

export default function PartnerAcko(OrderData, AddcloseModal) {
    const [ackoPersona, setAckoPersona] = useState('');
    const patientNameRef = useRef();

    return (
        <div className='flex flex-col gap-4 mt-2'>
            <input ref={patientNameRef} className='p-4 focus:outline-none placeholder:opacity-50  h-10 border-gray-200 border w-full' placeholder='Patient Name' defaultValue={OrderData?.mapUserPatient?.Patient?.name ? OrderData.mapUserPatient.Patient.name : ''}></input>
            <select onChange={(e) => setAckoPersona(e.target.value)} value={ackoPersona} className='w-full'>
                <option value=''>Select Acko Persona</option>
                {ackoContants.ACKO_PRODUCTS.map((product) => (
                    <option key={product.id} value={product.name}>{product.name}</option>
                ))}
            </select>
            <button className="text-lg p-2 w-full font-medium font-sans shadow-soft-xl rounded-lg bg-green-400 text-white-50" onClick={() => { generateOcs(OrderData, patientNameRef.current.value, ackoPersona); AddcloseModal(); }}>OCS</button>
        </div>
    )
}

PartnerAcko.propTypes = {
    OrderData: PropTypes.string,
    AddcloseModal: PropTypes.any
}
